module.exports = __webpack_public_path__ + "static_web/img/wb.d868f161.png";